import React from "react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-slate-200 py-12 px-6 md:px-12 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <div className="font-display font-bold text-slate-900">HI Power Savings AI</div>
          <p className="text-sm text-slate-500 mt-1">
            Powered by Maui Starpower Network &middot; Pilot in Hawaii &middot; Coming nationwide
          </p>
        </div>
        <p className="text-xs text-slate-400">
          Estimates are advisory and based on Hawaii utility rate models. Final pricing requires a site
          visit.
        </p>
      </div>
    </footer>
  );
}
